export default __webpack_public_path__ + "static/media/ted-garcia.d73fb6f3.png";